module.exports = __webpack_public_path__ + "img/br.0f7479b7.png";